module.exports = __webpack_public_path__ + "img/icon-arrow-up.1e0c28ed.svg";